import { fetchConToken } from "../helpers/fetch";
import { armarParametrosEmpadronamiento } from "../helpers/parametros";

const EmpadronamientoService = {
  getDocumentacionSolicitud: (idSolicitud) => {
    return fetchConToken(`DocumentacionSolicitudesEmpadronamiento/${idSolicitud}`);
  },
  deleteDocumentacionSolicitud: (idDocumento) => {
    return fetchConToken(
      `DocumentacionSolicitudesEmpadronamiento/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  getTiposDocumentacion: (idTipoEmpadronamiento, idPatologia) => {
    if (idTipoEmpadronamiento === null && idPatologia === null) {
      return fetchConToken(`TiposDocumentacionEmpadronamiento`);
    } else {
      return fetchConToken(`TiposDocumentacionEmpadronamiento?idTipoEmpadronamiento=${idTipoEmpadronamiento}&idPatologia=${idPatologia !== null ? idPatologia : ''}`);
    }
  },
  getPatologias: (idTipoEmpadronamiento) => {
    return fetchConToken(`TiposDocumentacionEmpadronamiento/TraerPatologias/${idTipoEmpadronamiento}`);
  },
  getBuscardorTipoEmpadronamientoTexto: (textoBuscado) => {
    return fetchConToken(`Empadronamiento/traerTipoEmpadronamientoPorTexto?textoBuscado=${textoBuscado}`);
  },
  getTiposEmpadronamiento: () => {
    return fetchConToken(`TipoEmpadronamiento`);
  },
  /*
  getTiposEmpadronamientoSegunEmpadronamientos: (idAfiliado) => {
    return fetchConToken(`TipoEmpadronamiento/traerSegunAfiliado?&idAfiliado=${idAfiliado}`);
  },
  */
  getTiposEmpadronamientoSegunEmpadronamientos: (idAfiliado) => {
    return fetchConToken(`TipoEmpadronamiento/traerSegunAfiliadoPorPatologia?&idAfiliado=${idAfiliado}`);
  },
  getEmpadronamientosHistorialPrevio: (idAfiliado) => {
    return fetchConToken(
      `Empadronamiento/traerHistorialEmpadronamientosPrevio?&idAfiliado=${idAfiliado}`
    );
  },
  getExcelConsultaEmpadronamientos: (
    idAfiliado,
    idTipoEmpadronamiento,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    esAuditor,
    esAuditorEsp,
    esAuditorDisca
  ) => {
    return fetchConToken(
      `Empadronamiento/generarExcel?${armarParametrosEmpadronamiento(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        null,
        null,
        null,
        null,
        null,
        null,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca
      )}`
    );
  },
  getSolicitudesBandeja: (
    idAfiliado,
    idTipoEmpadronamiento,
    fechaDesde,
    fechaHasta,
    fechaCargaDesde,
    fechaCargaHasta,
    idPatologia,
    idSolicitud,
    idEstadoSolicitud,
    esAuditor,
    esAuditorEsp,
    esAuditorDisca,
    esConsulta
  ) => {
    return fetchConToken(
      `Empadronamiento/traerBandejaSolicitudes?${armarParametrosEmpadronamiento(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        fechaCargaDesde,
        fechaCargaHasta,
        idPatologia,
        null,
        null,
        idSolicitud,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca,
        esConsulta
      )}`
    );
  },
  getContadoresEmpadronamientosBandeja: (idAfiliado,
    idTipoEmpadronamiento,
    fechaDesde,
    fechaHasta,
    fechaCargaDesde,
    fechaCargaHasta,
    idPatologia,
    idSolicitud,
    idEstadoSolicitud,
    esAuditor,
    esAuditorEsp,
    esAuditorDisca) => {
    return fetchConToken(
      `Empadronamiento/traerContadoresBandejaEmpadronamiento?${armarParametrosEmpadronamiento(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        fechaCargaDesde,
        fechaCargaHasta,
        idPatologia,
        null,
        null,
        idSolicitud,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca
      )}`
    );
  },
  getMedicacionBandeja: (
    idAfiliado,
    idSolicitud,
    idTipoEmpadronamiento,
    fechaDesde,
    fechaHasta,
    fechaCargaDesde,
    fechaCargaHasta,
    idPatologia,
        idSolicitudEmp,
        nroPedido,
    idEstadoSolicitud,
    esAuditor,
    esAuditorEsp,
    esAuditorDisca,
    esSoloInicio
  ) => {
    return fetchConToken(
      `Medicacion/traerBandejaMedicacion?${armarParametrosEmpadronamiento(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        fechaCargaDesde,
        fechaCargaHasta,
        idPatologia,
        idSolicitudEmp,
        nroPedido,
        idSolicitud,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca,
        null,
        esSoloInicio
      )}`
    );
  },
  getContadoresMedicacionBandeja: (idAfiliado,
    idSolicitud,
    idTipoEmpadronamiento,
    fechaDesde,
    fechaHasta,
    fechaCargaDesde,
    fechaCargaHasta,
    idPatologia,
        idSolicitudEmp,
        nroPedido,
    idEstadoSolicitud,
    esAuditor,
    esAuditorEsp,
    esAuditorDisca,
    esSoloInicio) => {
    return fetchConToken(
      `Medicacion/traerContadoresBandejaMedicacion?${armarParametrosEmpadronamiento(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        fechaCargaDesde,
        fechaCargaHasta,
        idPatologia,
        idSolicitudEmp,
        nroPedido,
        idSolicitud,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca,
        null,
        esSoloInicio
      )}`
    );
  },
  postSolicitudMedicacion: (data) => {
    return fetchConToken(`Medicacion`, data, "POST");
  },
  putSolicitudMedicacion: (data) => {
    return fetchConToken(`Medicacion`, data, "PUT");
  },
  postMedicamentosMedicacion: (medicamentos) => {
    return fetchConToken(`MedicacionMedicamentos`, medicamentos, "POST");
  },
  getMedicacionHistorialPrevio: (idAfiliado) => {
    return fetchConToken(
      `Medicacion/traerHistorialMedicacionPrevio?&idAfiliado=${idAfiliado}`
    );
  },
  getMigracionHistorialPrevio: (idAfiliado) => {
    return fetchConToken(
      `Medicacion/traerHistorialPrevioMigracion?&idAfiliado=${idAfiliado}`
    );
  },
  getMedicacionEmpadronamientosActivosHistorialPrevio: (idAfiliado) => {
    return fetchConToken(
      `Medicacion/traerHistorialEmpadronamientosActivos?&idAfiliado=${idAfiliado}`
    );
  },
  putSolicitudMedicacionFinalizada: (data) => {
    return fetchConToken(`Medicacion/modificarFinalizada`, data, "PUT");
  },
  setisponibilidadScienza: (data) => {
    return fetchConToken(`Scienza/NuevaDisponibilidad`, data, "POST");
  },
  imprimirSolicitudMedicacion: (idSolicitud) => {
    return fetchConToken(`Medicacion/generarPDF/${idSolicitud}`);
  },
  enviarSolicitudMedicacion: (idSolicitud) => {
    return fetchConToken(`Medicacion/generarMail/${idSolicitud}`);
  },
  postSolicitud: (data) => {
    return fetchConToken(`Empadronamiento`, data, "POST");
  },
  getExcelConsultaMedicacion: (
    idAfiliado,
    idTipoEmpadronamiento,
    fechaDesde,
    fechaHasta,
    idEstadoSolicitud,
    esAuditor,
    esAuditorEsp,
    esAuditorDisca
  ) => {
    return fetchConToken(
      `Medicacion/generarExcel?${armarParametrosEmpadronamiento(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        null,
        null,
        null,
        null,
        null,
        null,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca
      )}`
    );
  },
  tomarSolicitudMedicacion: (data) => {
    return fetchConToken(`Medicacion/tomarMedicacion`, data, "PUT");
  },
  liberarSolicitudMedicacion: (data) => {
    return fetchConToken(`Medicacion/liberarMedicacion`, data, "PUT");
  },
  putMedicacionRechazada: (data) => {
    return fetchConToken(`Medicacion/rechazarMedicacion`, data, "PUT");
  },
  putRechazarMedicacion: (data) => {
    return fetchConToken(`Medicacion/rechazarMedicacion`, data, "PUT");
  },
  putAnularMedicacion: (data) => {
    return fetchConToken(`Medicacion/anularMedicacion`, data, "PUT");
  },
  enviarRechazoMedicacion: (idSolicitud) => {
    return fetchConToken(`Medicacion/generarMailRechazo/${idSolicitud}`);
  },
  postRepetirMedicacion: (data) => {
    return fetchConToken(`Medicacion/repetirMedicacion`, data, "POST");
  },
  postRepetirSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/repetirSolicitud`, data, "POST");
  },
  putSolicitud: (data) => {
    return fetchConToken(`Empadronamiento`, data, "PUT");
  },
  putFechaFin: (data) => {
    return fetchConToken(`Empadronamiento/updateFechaFin`, data, "PUT")
  },
  tomarSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/tomarSolicitud`, data, "PUT");
  },
  liberarSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/liberarSolicitud`, data, "PUT");
  },
  postMedicamentos: (medicamentos) => {
    return fetchConToken(`EmpadronamientoMedicamentos`, medicamentos, "POST");
  },
  putSolicitudFinalizada: (data) => {
    return fetchConToken(`Empadronamiento/modificarFinalizada`, data, "PUT");
  },
  putSolicitudRechazada: (data) => {
    return fetchConToken(`Empadronamiento/rechazarSolicitud`, data, "PUT");
  },
  putRechazarSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/rechazarSolicitud`, data, "PUT");
  },
  putAnularSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/anularSolicitud`, data, "PUT");
  },
  imprimirSolicitud: (idSolicitud) => {
    return fetchConToken(`Empadronamiento/generarPDF/${idSolicitud}`);
  },
  enviarSolicitud: (idSolicitud) => {
    return fetchConToken(`Empadronamiento/generarMail/${idSolicitud}`);
  },
  enviarRechazoSolicitud: (idSolicitud) => {
    return fetchConToken(`Empadronamiento/generarMailRechazo/${idSolicitud}`);
  },
  devolverMedicacion: (data) => {
    return fetchConToken(`Medicacion/devolver/`, data, "PUT");
  },
  finalizarSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/finalizarSolicitud/`, data, "PUT");
  },
  devolverSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/devolverSolicitud/`, data, "PUT");
  },
  AutorizarSolicitud: (data) => {
    return fetchConToken(`Empadronamiento/AutorizarSolicitud/`, data, "PUT");
  },
  AgregarAlertaEmpadronamiento: (data) => {
    return fetchConToken(`Alertas/CargarAlerta/`, data, "POST");
  },
  ModificarAlertaEmpadronamiento: (data) => {
    return fetchConToken(`Alertas/`, data, "PUT");
  },
  GetAlertaPorEmp: (IdSolicitudEmp) => {
    return fetchConToken(`Alertas/${IdSolicitudEmp}`)
  },
  SendMailAlerta: (IdAfiliado) => {
    return fetchConToken(`Alertas/EnviarMail/${IdAfiliado}`)
  },
  getMedicamentosDeEmpadronamientoOriginal: (idSolicitudEmp) => {
    return fetchConToken(
      `Medicacion/traerMedicamentosDeEmpadronamiento?&idSolicitudEmp=${idSolicitudEmp}`
    );
  },
  getTrackingSolicitudEmp: (idSolicitud) => {
    return fetchConToken(`TrackingEmpadronamiento/traerTrackingPorSolicitud?&idSolicitud=${idSolicitud}`);
  },
  getTrackingSolicitudMed: (idSolicitud) => {
    return fetchConToken(`TrackingMedicacion/traerTrackingPorSolicitud?&idSolicitud=${idSolicitud}`);
  },
  //DOCUMENTACION SOLICITUD MEDICACION
  getDocumentacionSolicitudMedicacion: (idSolicitud) => {
    return fetchConToken(`DocumentacionSolicitudMedicacion/${idSolicitud}`);
  },
  deleteDocumentacionSolicitudMedicacion: (idDocumento) => {
    return fetchConToken(
      `DocumentacionSolicitudMedicacion/${idDocumento}`,
      {},
      "DELETE"
    );
  },
  //scienza
  getDisponibilidadScienza: (idMonodroga) => {
    return fetchConToken(`Scienza/DisponibilidadScienza/${idMonodroga}`)
  },
  getTrackingScienza: (idSolicEmp, idSolicMed) => {
    if (idSolicMed) {
      return fetchConToken(`Scienza/GetTrackingEnvios?idSolicMed=${idSolicMed}`)
    } else {
      return fetchConToken(`Scienza/GetTrackingEnvios?idSolicEmp=${idSolicEmp}`)

    }
  },
  getTrackingNosConecta: (idSolicEmp, idSolicMed) => {
    if (idSolicMed) {
      return fetchConToken(`Scienza/GetTrackingNosConecta?idSolicMed=${idSolicMed}`)
    } else {
      return fetchConToken(`Scienza/GetTrackingNosConecta?idSolicEmp=${idSolicEmp}`)

    }
  },
  //documentacion medicacion
  getTiposDocumentacionMedicacion: (idTipoEmpadronamiento, idPatologia) => {
    if (idTipoEmpadronamiento === null && idPatologia === null) {
      return fetchConToken(`TiposDocumentacionEmpadronamiento/TraerTiposDocumentacionMedicacion`);
    } else {
      return fetchConToken(`TiposDocumentacionEmpadronamiento/TraerTiposDocumentacionMedicacion?idTipoEmpadronamiento=${idTipoEmpadronamiento}&idPatologia=${idPatologia !== null ? idPatologia : ''}`);
    }
  },
  //Notas Solicitud Empadronamiento
  getNotas: (idSolicitud) => {
    return fetchConToken(`NotasSolicitudEmpadronamiento/traerPorSolicitud/${idSolicitud}`)
  },
  postNotas: (data, method) => {
    if (method === "POST") {
      return fetchConToken(`NotasSolicitudEmpadronamiento`, data, "POST")
    } else {
      return fetchConToken(`NotasSolicitudEmpadronamiento/`, data, "PUT")
    }
  },
  deleteNota: (data) => {
    return fetchConToken(`NotasSolicitudEmpadronamiento`, data, "DELETE");
  },
  // Notas Solicitud Medicacion
  getNotasMedicacion: (idSolicitud) => {
    return fetchConToken(`NotasSolicitudMedicacion/traerPorSolicitud/${idSolicitud}`)
  },
  postNotasMedicacion: (data, method) => {
    if (method === "POST") {
      return fetchConToken(`NotasSolicitudMedicacion`, data, "POST")
    } else {
      return fetchConToken(`NotasSolicitudMedicacion/`, data, "PUT")
    }
  },
  deleteNotaMedicacion: (data) => {
    return fetchConToken(`NotasSolicitudMedicacion`, data, "DELETE");
  },
  //TIPO NOTAS 
  getTiposNotasEmpadronamiento: () => {
    return fetchConToken(`TipoNotasEmpadronamiento`);
  },
  getTiposNotasEmpadronamientoTodas: () => {
    return fetchConToken(`TipoNotasEmpadronamiento/traerTodas`);
  },
  getConveniosScienza: () => {
    return fetchConToken(`Scienza/Convenios/traerTodos`);
  },
};

export default EmpadronamientoService;
